<div class="display-accordion-hierarchy">
    @if (rootNode$.value && rootVisible) {
        <adapt-display-navigation-node class="heading-node"
                                       [node]="rootNode$.value"></adapt-display-navigation-node>
    }
    @if (nonAccordionNodes.length > 0) {
        <ul>
            @for (node of nonAccordionNodes; track node) {
                <li>
                    <adapt-display-link-hierarchy [hierarchy]="node"
                                                  [expandAllLinks]="isMobileSize$ | async"></adapt-display-link-hierarchy>
                </li>
            }
        </ul>
    }

    @if (accordionNodes.length > 0) {
        <dx-accordion [dataSource]="accordionNodes"
                      itemTemplate="detail"
                      [collapsible]="true"
                      [multiple]="true"
                      keyExpr="$id">
            <div *dxTemplate="let node of 'title'">
                {{ node.title }}
            </div>
            <div *dxTemplate="let node of 'detail'">
                <ul>
                    @for (nodeChild of node.children; track nodeChild) {
                        @if (nodeChild.customData.displayAsAccordionInHierarchy) {
                            <li>
                                <adapt-display-accordion-hierarchy class="nested"
                                                                   [hierarchy]="nodeChild"
                                                                   [hideRootWithoutChildren]="true"></adapt-display-accordion-hierarchy>
                            </li>
                        } @else {
                            <li>
                                <adapt-display-link-hierarchy [hierarchy]="nodeChild"
                                                              [expandAllLinks]="isMobileSize$ | async"></adapt-display-link-hierarchy>
                            </li>
                        }
                    }
                </ul>
            </div>
        </dx-accordion>
    }
</div>
